export {core} from '../environment.core';

